import React from 'react';
import PropTypes from 'prop-types';

// PropTypes
import { jobPropTypes } from '../../../../proptypes/jobProptypes';

// Styles
import styles from './jobIntroduction.module.scss';

const JobIntroduction = ({ job }) => {
  if (!job.extra_info?.introduction) return null;

  return (
    <div className={styles.intro}>
      <div
        className="html-div"
        dangerouslySetInnerHTML={{
          __html: job.extra_info?.introduction,
        }}
      />
    </div>
  );
};

JobIntroduction.propTypes = {
  job: PropTypes.shape(jobPropTypes).isRequired,
};

export default JobIntroduction;
